<template>
  <div style="position: absolute;right: 0;top: 31vh;z-index: 99">
    <div class="floatBall displayMode">
      <div class="allSpace">
        <img class="pointer" src="../../assets/images/icon/全局空间白.png" v-if="displayData.val1 === 'allSpace'">
        <img @touchstart="setDisplay('allSpace','temperature')" @click="setDisplay('allSpace','temperature')" class="pointer" src="../../assets/images/icon/全局空间.png"
             v-else>
      </div>
      <div class="indoor">
        <img @touchstart="openBox('display')" @click="openBox('display')"
             class="pointer" src="../../assets/images/icon/内景图白.png" v-if="displayData.val1 === 'space'">
        <img @touchstart="openBox('display')" @click="openBox('display')"
             class="pointer" src="../../assets/images/icon/内景图.png" v-else>
      </div>
    </div>
    <div class="floatBall setting margin-top-10">
      <img @touchstart="openBox('setting')" @click="openBox('setting')" class="pointer" src="../../assets/images/icon/综合态势设置.png">
    </div>

    <!-- <div class="displayCollapse border-solid-blue" v-if="boxDisplay"
         :style="{width: boxModel==='setting' ? '520px' : '455px',height: boxModel==='setting' ? '300px': '180px'}"> -->
        <div class="displayCollapse border-solid-blue" v-if="boxDisplay"
        :style="{width: boxModel==='setting' ? '420px' : '350px',height: boxModel==='setting' ? '300px': '180px'}">
      <div style="height: 35px;line-height: 50px" class="text-center">
        <span style="color: rgb(51, 136, 229)" v-if="boxModel==='setting'">设置默认呈现方式</span>
        <i class="el-icon-close float-right font-weight-bold pointer"
           style="margin: 18px 18px 0 0" @touchstart="() =>{this.boxDisplay = false}" @click="() =>{this.boxDisplay = false}"></i>
      </div>
      <div style="padding: 20px 30px">
        <!--设置-->
        <el-radio-group v-if="boxModel==='setting'" v-model="displaySystem.val1"
                        @change="changeVal('val1')">
          <div>
            <el-radio label="allSpace">
              <span>方式一：</span>
              <img src="../../assets/images/comprehensive/allSpace.jpg" class="img" :style="imgBorder(displaySystem.val2,'temperature')">
              <div class="text-white text-right" style="line-height: 35px;margin-right: 11px;">全局空间</div>
            </el-radio>
          </div>
          <div class="margin-top-10">
            <el-radio label="space">
              <span>方式二：</span>
              <div style="display: contents">
                <img src="../../assets/images/comprehensive/indoor.jpg" class="img" :style="imgBorder(displaySystem.val2,'indoor')">
                <img src="../../assets/images/comprehensive/list.jpg" class="img" style="margin-left: 15px" :style="imgBorder(displaySystem.val2,'list')">
                <img src="../../assets/images/comprehensive/map.jpg" class="img" style="margin-left: 15px" :style="imgBorder(displaySystem.val2,'map')">
                <!-- <img src="../../assets/images/comprehensive/networkTopology.png" class="img" style="margin-left: 15px" :style="imgBorder(displaySystem.val2,'networkTopology')"> -->
                <!-- <div style="line-height: 35px;font-size: 0.85rem;margin-left: 17%"> -->
                <div style="line-height: 35px;font-size: 0.85rem;margin-left: 24%">
                  <el-radio-group v-model="displaySystem.val2"
                                  style="font-size: 0.85rem"
                                  @change="changeVal('val2')">
                     <el-radio label="indoor">内景图</el-radio>
                    <el-radio label="list" style="margin-left: -2px">组态列表</el-radio>
                    <el-radio label="map" style="margin-left: -8px">GIS地图</el-radio>
                    <!-- <el-radio label="indoor"  style="margin-left: 4px">内景图</el-radio>
                    <el-radio label="list" style="margin-left: 6px;margin-right: 20px;">组态列表</el-radio>
                    <el-radio label="map" style="margin-left: 4px;margin-right: 20px;">GIS地图</el-radio> -->
                    <!-- <el-radio label="networkTopology" style="margin-left: 4px">拓扑图</el-radio> -->
                  </el-radio-group>
                </div>
              </div>
            </el-radio>
          </div>
        </el-radio-group>
        <!--显示-->
        <div v-else style="display: contents;">
          <img src="../../assets/images/comprehensive/indoor.jpg" class="img" :style="imgBorder(displayData.val2,'indoor')">
          <img src="../../assets/images/comprehensive/list.jpg" class="img" style="margin-left: 15px" :style="imgBorder(displayData.val2,'list')">
          <img src="../../assets/images/comprehensive/map.jpg" class="img" style="margin-left: 15px" :style="imgBorder(displayData.val2,'map')">
          <!-- <img src="../../assets/images/comprehensive/networkTopology.png" class="img" style="margin-left: 15px" :style="imgBorder(displayData.val2,'networkTopology')"> -->
          <div style="line-height: 35px;font-size: 0.85rem;margin-left: 8px">
            <el-radio-group v-model="displayData.val2"
                            style="font-size: 0.85rem"
                            @change="setDisplay('space',displayData.val2)">
              <el-radio label="indoor">内景图</el-radio>
              <el-radio label="list" style="margin-left: -2px">组态列表</el-radio>
              <el-radio label="map" style="margin-left: -8px">GIS地图</el-radio>
              <!-- <el-radio label="indoor" style="margin-left: 4px;margin-right: 20px;">内景图</el-radio>
              <el-radio label="list" style="margin-left: 4px;margin-right: 20px;">组态列表</el-radio>
              <el-radio label="map" style="margin-left: 2px;margin-right: 20px;">GIS地图</el-radio> -->
              <!-- <el-radio label="networkTopology" style="margin-left: 8px">拓扑图</el-radio> -->
            </el-radio-group>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {saveOrUpdateSystematic} from "@/network/systematic";

export default {
  name: "FloatBall",
  props: ['displaySystem', 'code','displayData'],
  inject: ['reload'],
  data() {
    return {
      boxDisplay: false,
      boxModel: 'display',
    }
  },
  methods: {
    display(val) {
      this.$emit('changeMode', val)
    },
    openBox(val) {
      if (this.boxModel === val){
        this.boxDisplay = !this.boxDisplay
      }else{
        this.boxDisplay = true
      }
      this.boxModel = val
    },
    setDisplay(val1, val2) {
      this.$emit('changeMode', val1, val2)
      this.boxDisplay = false
    },
    changeVal(filed) {
      let val2 = this.displaySystem.val2
      let val1 = this.displaySystem.val1
      if (filed === 'val2'){
        if (this.displaySystem.val2 !== 'temperature'){
          val1 = 'space'
        }
      }else if (filed === 'val1'){
        if (this.displaySystem.val1 === 'allSpace') {
          val2 = "temperature"
        }else{
          val2 = 'indoor'
        }
      }
      const params = {
        name: "概览呈现方式",
        code: this.code,
        val1: val1,
        val2: val2
      }
      saveOrUpdateSystematic([params]).then(res => {
        if (res.code === 0) {
          this.reload()
          this.boxDisplay = false
        }
      })
    },
    imgBorder(val,display){
      if (val === display){
        return `border-color: rgb(51, 136, 229)`
      }
    }

  }
}
</script>

<style scoped>
.floatBall {
  width: 50px;
  background-color: rgba(11, 50, 94, .8);
  border-radius: 2px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center
}

.displayMode {
  height: 90px;
}
.allSpace {
  padding-bottom: 10px;
  border-bottom: 1px solid #3A5575;
}

.indoor {
  margin-top: 5px;
}

.setting {
  height: 45px;
}

.displayCollapse {
  width: 200px;
  height: 200px;
  background-image: url('/static/background.png');
  background-repeat: no-repeat;
  background-size: cover;
  position: absolute;
  right: 60px;
  top: 0
}

.img {
  width: 80px;
  height: 55px;
  border: 1px solid #3A5575;
}
</style>
